/*
 * Types.
 */

/** Selectable separators for the export columns. */
export enum SeparatorsEnum {
  COMMA = ',',
  SEMICOLON = ';',
  TAB = '\t',
}
